import React, {useEffect, useContext} from 'react';
import { Box, Button, Stack, TableCell, TextField, Typography, IconButton, Dialog, Backdrop, CircularProgress, MenuItem } from '@mui/material';
import {Context} from '../App';
import SorTableCheckable from '../components/ui/sortable-checkable';
import { Add, DeleteForever, Edit, FlakyRounded, InfoOutlined } from '@mui/icons-material';
import PromoForm from '../components/forms/promo';
import moment from 'moment';
import 'moment/locale/fr';
import AppLayout from '../components/layout/AppLayout';

export default function Promotions() {
    const {setIsConnected} = useContext(Context)
    const user = JSON.parse(sessionStorage.getItem('user'))
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [events, setEvents] = React.useState([]);
    const [eventId, setEventId] = React.useState('');
    const [promos, setPromos] = React.useState([]);
    const [promo, setPromo] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');

    const table = [
        {header: "Titre", sortable: true, sortBy:(el)=>el.titre.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'150px'}}>{row.titre}</TableCell>},
        {header: "Évènement", row: (row, index)=><TableCell key={index} sx={{minWidth:'50px', textAlign:'center'}}>{row.events.map(event => event.titre).join(', ')}</TableCell>},
        {header: "Statut", sortable: true, sortBy:(el)=>el.isActive, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'50px'}}>{row.isActive ? 'Actif' : 'Inactif'}</TableCell>},
        {header: "Réduction", sortable: true, sortBy:(el)=>el.reduction, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'50px'}}>{row.isPercentage ? row.reduction+' %' : (row.reduction?.toFixed(2)+' €')}</TableCell>},
        {header: "Code", sortable: false, row: (row, index)=><TableCell key={index} style={{minWidth:'200px'}}>{row.code}</TableCell>},
        {header: "Sponsor", sortable: true, sortBy:(el)=>el.sponsor, row: (row, index)=><TableCell key={index} style={{minWidth:'200px'}}>{row.sponsor}</TableCell>},
        {header: "Utilisation", sortable: true, sortBy:(el)=>el.usage, row: (row, index)=><TableCell key={index} style={{minWidth:'70px', textAlign:'center'}}>{row.usage}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setPromo(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label={row.isActive ? "désactiver" : "activer"} onClick={()=>{setPromo(row); manage_dialog(true, 'toggle')}}><FlakyRounded fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setPromo(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setPromo(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.titre+' '+item.events.map(event => event.titre).join(', ')+' '+item.code+' '+item.sponsor+' '+item.reduction+' '+item.usage
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setPromo()
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    useEffect(()=> {
        if (!(!!eventId)) return;
        setLoad(true);

        const query = new URLSearchParams({events: eventId}).toString();

        fetch(process.env.REACT_APP_API_URL.concat('/promos?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setPromos(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching promos:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, [eventId])
    
    useEffect(()=> {
        if(events.length > 0 && !eventId) {
            if (events.length === 1) {
                setEventId(events[0]._id);
            } else {
                const nearestEvent = events.reduce((prev, curr) => {
                    const prevDate = new Date(prev.date);
                    const currDate = new Date(curr.date);
                    return (prevDate < currDate) ? prev : curr;
                });
                setEventId(nearestEvent._id);
            }
        }
    },  [events])

    useEffect(() => {
        if (!user || user.role === 'user') {
            sessionStorage.clear();
            setIsConnected(false);
        }

        if (user.role === 'admin' && user.events.length === 1) {
            setEventId(user.events[0]);
            return;
        }

        const query = user.role==='admin' ? {_id: {$in: user.events}} :{};

        fetch(process.env.REACT_APP_API_URL.concat('/events'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify(query)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setEvents(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching events:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <AppLayout>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2}}>
                <Typography variant='h4' marginBlock={3} align='center'>
                    Gestionnaire de code Promo
                </Typography>
                <Typography variant='body1' marginBlock={1} align='center'>
                    Vous pouvez créer, modifier, activer/désactiver et supprimer des codes promo pour vos évènements.
                </Typography>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    {(user?.role==='super admin' || user.events.length > 1) && <TextField select label='Évènement' value={eventId} onChange={(e) => setEventId(e.target.value)} size="small" sx={{minWidth:'200px', width:'30%'}}>
                        {events.map((p, index) => (
                            <MenuItem key={index} value={p._id}>{p.titre}</MenuItem>
                        ))}
                    </TextField>}
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher un code promo..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} startIcon={<Add/>}>
                        Nouveau
                    </Button>
                </Stack>

                <SorTableCheckable {...{data:promos.filter(reg=>searchFilter(reg, searchInput)),table, selectItems, setItems, rowsPerPage:25, rowsPerPageOptions:[25,50,100]}}/>
            </Box>

            <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:'md', fullWidth:true}}>
                {action === 'add' && <PromoForm {...{close:()=>manage_dialog(false), showResult, listEvents: events, setPromos}}/>}
                {action === 'edit' && <PromoForm {...{close:()=>manage_dialog(false), showResult, listEvents: events, setPromos, promo}}/>}
            </Dialog>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </AppLayout>
    )
}

